import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA1tfoT081ppG28RXpjLI6N9HI6X9d0lKM",
  authDomain: "unotsu-nobuko.firebaseapp.com",
  projectId: "unotsu-nobuko",
  storageBucket: "unotsu-nobuko.firebasestorage.app",
  messagingSenderId: "565114533506",
  appId: "1:565114533506:web:26803885838cf94dd7a69b",
  measurementId: "G-L099XT2BTT"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app, "gs://unotsu-nobuko.firebasestorage.app");
const auth = getAuth(app);

// Explicitly control emulator usage via env var to avoid accidental empty data on localhost
// Set REACT_APP_USE_FIREBASE_EMULATOR=true when you actually run emulators locally
const shouldUseEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true';
if (shouldUseEmulators) {
  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectStorageEmulator(storage, 'localhost', 9199);
    // eslint-disable-next-line no-console
    console.log("[Firebase] Connected to local emulators");
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("[Firebase] Error connecting to emulators: ", error);
  }
}

export { db, storage, auth };
